import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="selectdropdown"
export default class extends Controller {
    connect() {
    }

    change(event) {

        let selected = [];
        for (let option of event.target.options) {
            if (option.selected) {
                selected.push(option.value);
            }
        }

        let value = selected;
        let loader = document.getElementById(event.target.dataset.loader);
        let content = event.target.dataset.extraParam
        let contents = document.getElementsByClassName(content);
        if (loader && contents.length) {
            loader.classList.remove("hidden")
            for (const e of contents) {
                e.classList.add("hidden")
            }
        }
        let url = new URL(event.target.dataset.url)
        url.searchParams.set(event.target.dataset.extraParam, value)
        fetch(url, {
            method: "GET",
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(response => response.text())
            .then(html => {
                if (loader && contents.length) {
                    loader.classList.add("hidden")
                    for (const e of contents) {
                        e.classList.remove("hidden")
                    }
                }
                Turbo.renderStreamMessage(html)
            })
    }
}
